import React from "react";

const LowerLine = () => {
    return (
        <svg
            width="239"
            height="86"
            viewBox="0 0 239 86"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g filter="url(#filter0_d_1077_13178)">
                <path
                    d="M5 1C35.5257 47.4433 143.515 107.848 234 58.721"
                    stroke="#007FB6"
                    strokeWidth="2"
                    strokeDasharray="5 5"
                />
            </g>
            <defs>
                <filter
                    id="filter0_d_1077_13178"
                    x="0.164551"
                    y="0.451172"
                    width="238.312"
                    height="85.5488"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="4" />
                    <feGaussianBlur stdDeviation="2" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_1077_13178"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_1077_13178"
                        result="shape"
                    />
                </filter>
            </defs>
        </svg>
    );
};

export default LowerLine;
